export const PANEL_TYPE = {
  ONE_PANEL: {
    type: 0,
    title: 'company.settings.text_panels.one_panel',
  },
  TWO_PANELS: {
    type: 1,
    title: 'company.settings.text_panels.two_panels',
  },
};

export const EXAMPLE_TOP_TEXT = 'Mattheus Aditi Fryderyk';
export const EXAMPLE_BOTTOM_TEXT = 'Senior project manager';

export const PREVIEW_IDS = {
  landscape: 'landscape-text-panel-preview',
  portrait: 'portrait-text-panel-preview',
  square: 'square-text-panel-preview',
};

export const SPACE_BETWEEN_PANELS_MIN_VALUE = 0; // px
export const SPACE_BETWEEN_PANELS_MAX_VALUE = 10; // px

export const OPACITY_MIN_VALUE = 1; // %
export const OPACITY_MAX_VALUE = 100; // %

export const MARGIN_MIN_VALUE = 0; // %
export const MARGIN_MAX_VALUE = 50; // %

export const FONT_SIZE_MIN = 1; // px
export const FONT_SIZE_MAX = 50; // px

export const BORDER_RADIUS_MIN = 0; // px
export const BORDER_RADIUS_MAX = 100; // px

export const BORDER_WIDTH_MIN = 0; // px
export const BORDER_WIDTH_MAX = 20; // px

export const PADDING_MIN = 0; // px
export const PADDING_MAX = 50; // px

export const PANEL_NAME = {
  TOP: 'top',
  BOTTOM: 'bottom',
};

export const INITIAL_TEXT_PANEL_SETTINGS = {
  top: {
    backgroundColor: null,
    borderColor: '#7e73ac',
    borderRadius: 0,
    borderWidth: 0,
    fontSize: 14,
    opacity: 100,
    fontColor: '#FFFFFF',
  },
  bottom: {
    backgroundColor: null,
    borderColor: '#7e73ac',
    borderRadius: 0,
    borderWidth: 0,
    fontSize: 12,
    opacity: 100,
    fontColor: '#FFFFFF',
  },
  bgColor: '#7e73ac',
  active: false,
  spacing: 0,
  marginX: 10,
  marginY: 30,
  position: 'bl',
  textPadding: '5 10 5 10',
  title: 'New text panel',
  type: 0,
};
